import { useTranslation } from "react-i18next";
import styles from "@/components/appointmentRequest/assignmentPlanner/planner.module.css";

export default function PlannerToggle({
  all,
  onChange,
  freeLabel,
}: {
  all: boolean;
  onChange: (all: boolean) => void;
  freeLabel?: string;
}) {
  const { t } = useTranslation();
  return (
    <div className={styles.segment}>
      <button type="button" aria-pressed={all} onClick={() => onChange(true)}>
        {t("planner.all")}
      </button>
      <button type="button" aria-pressed={!all} onClick={() => onChange(false)}>
        {freeLabel ?? t("planner.unassigned")}
      </button>
    </div>
  );
}
